module.exports = __webpack_public_path__ + "img/desk&lamps.901acaa5.jpg";